<template>
  <div class="customer-card">
    <div
      v-watermark="{
        text:
          userInfo.userName +
          ' ' +
          userInfo.mobile.substring(userInfo.mobile.length - 4),
      }"
      class="water"
    />
    <div class="card-header">
      <div class="header-bg"></div>
      <div class="info-box">
        <van-image
          round
          width="81px"
          height="81px"
          fit="cover"
          :src="customInfo.avatar"
        />
        <div class="user-info">
          <div class="nickname">
            {{ customInfo.name }}
            <img
              v-if="customInfo.gender === '2'"
              :src="IconFemale"
              class="sex"
            />
            <img v-if="customInfo.gender === '1'" :src="IconMale" class="sex" />
          </div>
          <div v-show="customInfo.phone" class="phone">
            <img
              src="../../../assets/img/customer/icon_phone.png"
              class="icon-phone"
            />
            {{ customInfo.phone }}
          </div>
          <div class="stage">
            <img
              v-if="basicInfo.stageId === 0"
              :src="Stage0"
              class="icon-stage"
            />
            <img
              v-if="basicInfo.stageId === 1"
              :src="Stage1"
              class="icon-stage"
            />
            <img
              v-if="basicInfo.stageId === 2"
              :src="Stage2"
              class="icon-stage"
            />
            <img
              v-if="basicInfo.stageId === 3"
              :src="Stage3"
              class="icon-stage"
            />
            <img
              v-if="basicInfo.stageId === 5"
              :src="Stage5"
              class="icon-stage"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="tab-box">
      <van-tabs v-model="activeName">
        <van-tab title="客户信息">
          <van-dropdown-menu class="filter-box">
            <!-- <van-dropdown-item v-model="value1" :title="value1" :options="allList" @change="changeStage" /> -->
            <van-dropdown-item ref="fieldItem" class="dropdown" :title="value1">
              <van-search
                v-model="searchField"
                placeholder="请输入"
                @input="changeField"
              />
              <van-cell
                v-for="(item, i) in curFieldList"
                :key="i"
                :title="item.text"
                @click="filterField(item.text)"
              />
            </van-dropdown-item>
            <van-dropdown-item
              v-model="value2"
              :title="value2"
              :options="stageList"
              @change="changeStage"
            />
          </van-dropdown-menu>
          <customer-info
            :active-name="activeName"
            :one-id="oneId"
            :group-list="groupList"
            @on-refresh="fetchUserDetail"
          />
        </van-tab>
        <van-tab title="客户动态">
          <customer-track
            ref="refTrack"
            :user-name="customInfo.name"
            :one-id="oneId"
          />
        </van-tab>
      </van-tabs>
    </div>

    <div class="floating-btn" @click="onOpenAddRecord">
      <img :src="IconPlus" />
    </div>

    <add-record
      v-show="showFloating"
      ref="refAddRecord"
      :custom-info="customInfo"
      @on-close="onCloseAddRecord"
      @on-refresh="onRefresh"
    />
  </div>
</template>

<script>
import '../constant';
import CustomerInfo from './customerInfo.vue';
import CustomerTrack from './customerTrack.vue';
import AddRecord from './addRecord.vue';
import IconMale from '../../../assets/img/customer/icon_male.png';
import IconFemale from '../../../assets/img/customer/icon_female.png';
import IconPlus from '../../../assets/img/customer/icon_plus.png';
import Stage0 from '../../../assets/img/customer/curstage_0.png';
import Stage1 from '../../../assets/img/customer/curstage_1.png';
import Stage2 from '../../../assets/img/customer/curstage_2.png';
import Stage3 from '../../../assets/img/customer/curstage_3.png';
import Stage5 from '../../../assets/img/customer/curstage_5.png';
import store from '@/store/index';
import moment from 'moment';
// import { getUserDetail, getUserStageDetail, getCustomGroupList, getStageList, getCurStage } from '@/api/modules/custom'
import {
  getUserStageDetail,
  getCustomGroupList,
  getStageList,
  getCurStage,
} from '@/api/modules/custom';
import { mapGetters } from 'vuex';
import Vue from 'vue';

Vue.directive('watermark', (el, binding) => {
  const addWaterMarker = (text, el) => {
    var canvas = document.createElement('canvas');
    var cans = canvas.getContext('2d');
    cans.rotate((-45 * Math.PI) / 180); // 旋转弧度
    cans.font = '16px Microsoft JhengHei'; // 字体
    cans.fillStyle = 'rgba(0, 0, 0, 0.1)'; // 字体填充颜色
    cans.textAlign = 'left'; // 对齐方式
    cans.textBaseline = 'Middle'; // 基线
    cans.fillText(text, '', canvas.height); // 被填充的文本
    el.style.backgroundImage = `url(${canvas.toDataURL(`image/png`)})`; // 插入背景图
  };
  const { text } = binding.value;
  addWaterMarker(text, el);
});
export default {
  components: {
    CustomerInfo,
    CustomerTrack,
    AddRecord,
  },
  data() {
    return {
      externalId: '',
      // externalId: 'wmtw8EEQAA5S7OmcGpiPGLJ6ZIUtmWCA', // 用于本地开发
      IconMale,
      IconFemale,
      IconPlus,
      Stage0,
      Stage1,
      Stage2,
      Stage3,
      Stage5,
      basicInfo: '',
      activeName: 0,
      showFloating: true,
      inited: false,
      groupList: [],
      customInfo: {
        name: '',
        avatar: '',
        phone: '',
        gender: '',
        oneId: '',
      },
      oneId: '',
      stageList: [],
      allList: [],
      curFieldList: [],
      value1: '信息筛选',
      value2: '阶段筛选',
      searchField: '',
    };
  },
  computed: {
    ...mapGetters({
      userInfo: 'userAuth/getUsersCurrentInfo',
    }),
  },
  async created() {
    const externalId = this.externalId || store.state.userAuth.customerInfo;
    const stageRes = await getCurStage({ externalId });
    this.basicInfo = stageRes.data;
    const res = await getStageList();
    this.stageList = res.data.map((item) => {
      return {
        text: item.stageName,
        value: item.stageName,
        id: item.stageId,
      };
    });
    this.stageList.unshift({ text: '全部', value: '全部' });
    this.fetchUserDetail();
  },

  methods: {
    getCurStageName() {
      return this.stageList.filter(
        (item) => item.id === this.basicInfo.stageId
      )[0].text;
    },
    onRefresh() {
      this.$refs.refTrack && this.$refs.refTrack.fetchUserTrail();
    },

    onCloseAddRecord() {
      this.showFloating = false;
    },
    onOpenAddRecord() {
      this.$refs.refAddRecord.showPopup = true;
    },

    getAddWayText(val) {
      switch (val) {
        case '10001':
          return '企微添加';
        default:
          return '';
      }
    },
    changeField() {
      if (this.searchField) {
        this.curFieldList = this.allList.filter((item) =>
          item.text.toLowerCase().includes(this.searchField.toLowerCase())
        );
      } else {
        this.curFieldList = this.allList;
      }
    },
    filterField(text) {
      this.value1 = text;
      this.changeStage();
      this.$refs.fieldItem.toggle();
    },
    async changeStage() {
      if (this.value2 === '全部' || this.value2 === '阶段筛选') {
        this.fetchUserDetail();
      }
      const externalId = this.externalId || store.state.userAuth.customerInfo;
      const stageRes = await getUserStageDetail({ externalId });
      if (stageRes.code === 0) {
        let res = '';
        const resList = stageRes.data.filter(
          (item) => item.stageName === this.value2
        );
        if (resList.length) {
          res = resList[0].fields.filter((item) => +item.isActive === 1);
          const oList = res.sort((a, b) => a.sort - b.sort);
          const list = [];
          oList.forEach((item) => {
            if (
              ['name', 'avatar', 'phone', 'gender'].includes(item.customNameEn)
            ) {
              this.customInfo[item.customNameEn] = item.customValue;
            } else {
              if (item.customNameEn === 'oneId') {
                this.oneId = item.customValue;
                this.customInfo.oneId = item.customValue;
              }
              if (item.customNameEn === 'createTime' && item.customValue) {
                item.customValue = moment(Number(item.customValue)).format(
                  'YYYY-MM-DD HH:mm:ss'
                );
              }

              if (item.customNameEn === 'addWay' && item.customValue) {
                item.customValue = this.getAddWayText(item.customValue);
              }
              item.stageId = resList[0].stageId;
              list.push(item);
            }
          });
          this.groupList.forEach((item) => {
            if (this.value1 !== '信息筛选' && this.value1 !== '全部') {
              item.child = list.filter(
                (k) => k.customGroup === item.id && k.customName === this.value1
              );
            } else {
              item.child = list.filter((k) => k.customGroup === item.id);
            }
          });
        } else {
          this.groupList.forEach((item) => {
            item.child = [];
          });
        }
      }
    },
    async fetchUserDetail() {
      const groupRes = await getCustomGroupList({
        tenantId: global.APP_CONFIG.tenantId,
      });
      if (groupRes.code === 0) {
        if (groupRes.data.length > 0) {
          const groupList = [];
          groupList.push(...groupRes.data);
          const externalId =
            this.externalId || store.state.userAuth.customerInfo;
          const stageRes = await getUserStageDetail({ externalId });
          if (stageRes.code === 0) {
            let res = '';
            const resList = stageRes.data.filter(
              (item) => item.stageId === this.basicInfo.stageId
            );
            if (resList.length) {
              res = resList[0].fields.filter((item) => +item.isActive === 1);
              this.allList = res
                .filter((item) => item.customName)
                .map((item) => {
                  return {
                    ...item,
                    text: item.customName,
                    value: item.customName,
                  };
                });
              this.allList.unshift({ text: '全部', value: '全部' });
              this.curFieldList = this.allList;
              const oList = res.sort((a, b) => a.sort - b.sort);
              const list = [];
              oList.forEach((item) => {
                if (
                  ['name', 'avatar', 'phone', 'gender'].includes(
                    item.customNameEn
                  )
                ) {
                  this.customInfo[item.customNameEn] = item.customValue;
                } else {
                  if (item.customNameEn === 'oneId') {
                    this.oneId = item.customValue;
                    this.customInfo.oneId = item.customValue;
                  }
                  if (item.customNameEn === 'createTime' && item.customValue) {
                    item.customValue = moment(Number(item.customValue)).format(
                      'YYYY-MM-DD HH:mm:ss'
                    );
                  }

                  if (item.customNameEn === 'addWay' && item.customValue) {
                    item.customValue = this.getAddWayText(item.customValue);
                  }
                  const stageAllList = [];
                  stageRes.data.forEach((a) => {
                    a.fields.forEach((b) => {
                      if (
                        b.customName === item.customName &&
                        b.customGroup === item.customGroup
                      ) {
                        b.stageId = a.stageId;
                        stageAllList.push(b);
                        if (stageAllList.length > 1) {
                          item.stageAllList = stageAllList;
                        }
                      }
                    });
                  });
                  list.push(item);
                }
              });
              groupList.forEach((item) => {
                if (this.value1 !== '信息筛选' && this.value1 !== '全部') {
                  item.child = list.filter(
                    (k) =>
                      k.customGroup === item.id && k.customName === this.value1
                  );
                } else {
                  item.child = list.filter((k) => k.customGroup === item.id);
                }
              });
            } else {
              groupList.forEach((item) => {
                item.child = [];
              });
            }
          }
          this.groupList = groupList;
        }
      }

      // const externalId = this.externalId || store.state.userAuth.customerInfo
      // console.log('store.state.userAuth.customerInfo', store.state.userAuth)
      // const groupRes = await getCustomGroupList({
      //   tenantId: global.APP_CONFIG.tenantId
      // })
      // if (groupRes.code === 0) {
      //   if (groupRes.data.length > 0) {
      //     const groupList = []
      //     groupList.push(...groupRes.data)
      //     const res = await getUserDetail({ externalId })
      //     if (res.code === 0) {
      //       // await getDealers({ latitude: '', longitude: '' })
      //       res.data = res.data.filter(item => +item.isActive === 1)
      //       this.allList = res.data.filter(item => item.customName).map(item => {
      //         return {
      //           ...item,
      //           text: item.customName,
      //           value: item.customName
      //         }
      //       })
      //       this.allList.unshift({ text: '全部', value: '全部' })
      //       const oList = res.data.sort((a, b) => a.sort - b.sort)
      //       const list = []
      //       oList.forEach(item => {
      //         if (
      //           ['name', 'avatar', 'phone', 'gender'].includes(
      //             item.customNameEn
      //           )
      //         ) {
      //           this.customInfo[item.customNameEn] = item.customValue
      //         }
      //         else {
      //           if (item.customNameEn === 'oneId') {
      //             this.oneId = item.customValue
      //             this.customInfo.oneId = item.customValue
      //           }
      //           if (item.customNameEn === 'createTime' && item.customValue) {
      //             item.customValue = moment(Number(item.customValue)).format(
      //               'YYYY-MM-DD HH:mm:ss'
      //             )
      //           }

      //           if (item.customNameEn === 'addWay' && item.customValue) {
      //             item.customValue = this.getAddWayText(item.customValue)
      //           }
      //           list.push(item)
      //         }
      //       })
      //       groupList.forEach(item => {
      //         if (this.value1 !== '信息筛选' && this.value1 !== '全部') {
      //           item.child = list.filter(k => k.customGroup === item.id && k.customName === this.value1)
      //         }
      //         else {
      //           item.child = list.filter(k => k.customGroup === item.id)
      //         }
      //       })
      //     }
      //     this.groupList = groupList
      //   }
      // }
    },
  },
};
</script>

<style lang="less" scoped>
.customer-card {
  /deep/ .van-cell {
    position: relative;
    z-index: 100;
    background-color: unset;
  }
  position: relative;
  // height: 100vh;
  .water {
    width: 100%;
    position: absolute;
    height: 100%;
    z-index: 100;
  }
  .card-header {
    position: relative;
    height: 170px;
    box-sizing: border-box;
    background-color: #fff;
    .header-bg {
      width: 100%;
      height: 108px;
      position: absolute;
      top: 0;
      left: 0;
      background-color: #4873c0;
    }
    .info-box {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      padding-left: 25px;
      position: relative;
      z-index: 1;
      background: url('../../../assets/img/customer/card_bg.png') no-repeat;
      background-size: cover;
      display: flex;
      align-items: center;

      .user-info {
        box-sizing: border-box;
        padding: 12px 8px;
        height: 81px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .nickname {
          font-size: 18px;
          color: #333;
          font-weight: bold;
          .sex {
            width: 12px;
          }
        }
        .phone {
          font-size: 14px;
          color: #333;
          display: flex;
          align-items: center;
          .icon-phone {
            width: 14px;
          }
        }
        .stage {
          .icon-stage {
            width: 145px;
            height: 24px;
          }
        }
      }
    }
  }

  .tab-box {
    position: relative;
    .filter-box {
      position: relative !important;
      z-index: 200;
      .dropdown {
        /deep/ .van-dropdown-item {
          position: relative !important;
          top: 0 !important;
        }
        /deep/ .van-dropdown-item__content {
          position: relative;
          max-height: 100vh;
          overflow: auto;
        }
        /deep/ .van-overlay {
          position: fixed !important;
        }
      }
    }
    /deep/ .van-tabs {
      .van-tabs__nav {
        .van-tab {
          position: relative;
          z-index: 200;
          flex: none;
          margin-left: 20px;
        }
        .van-tabs__line {
          width: 23px;
          height: 3px;
          background-color: #4873c0;
          margin-bottom: 3px;
        }
      }
    }
  }

  .floating-btn {
    position: fixed;
    right: 23px;
    bottom: 23px;
    width: 50px;
    height: 50px;
    z-index: 200;
    img {
      width: 100%;
    }
  }
}
</style>
